var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.0001V10.0001C2 9.73486 2.10536 9.4805 2.29289 9.29296C2.48043 9.10543 2.73478 9.00007 3 9.00007H5.697C5.89453 9.00012 6.08765 8.94166 6.252 8.83207L10.445 6.03607C10.5957 5.9355 10.771 5.87778 10.952 5.86907C11.133 5.86037 11.313 5.90102 11.4726 5.98667C11.6323 6.07232 11.7658 6.19975 11.8586 6.35535C11.9515 6.51095 12.0004 6.68886 12 6.87007V17.1301C12 17.3111 11.9509 17.4888 11.8579 17.6441C11.7648 17.7994 11.6314 17.9265 11.4718 18.0119C11.3121 18.0974 11.1323 18.1378 10.9515 18.129C10.7707 18.1203 10.5956 18.0626 10.445 17.9621L6.252 15.1671C6.08754 15.0578 5.89443 14.9997 5.697 15.0001H3C2.73478 15.0001 2.48043 14.8947 2.29289 14.7072C2.10536 14.5196 2 14.2653 2 14.0001V14.0001Z",
    stroke: "#CFCFCF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.5C16.5 7.5 18 9 18 11.5C18 14 16.5 15.5 16.5 15.5M19.5 4.5C19.5 4.5 22 7 22 11.5C22 16 19.5 18.5 19.5 18.5",
    stroke: "#CFCFCF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUp);
export default __webpack_public_path__ + "static/media/volume_up.81a482fe0d23e78c6e6b0d8fba19436f.svg";
export { ForwardRef as ReactComponent };